
import { defineComponent, ref } from 'vue'
import { useOrganizationModule } from '@/modules/organizations'
import { useBillingTemplateModule } from '@/modules/billing-templates'
import { AgreementsRouteNames, OrganizationsRouteNames } from '@/router/routes-names'
import { useRoute, useRouter } from 'vue-router'
import useQuasar from 'quasar/src/composables/use-quasar.js';

export default defineComponent({
    name: 'view-agreements-new-agreement',
    async setup () {
        const route = useRoute()
        const router = useRouter()
        const $q = useQuasar()
        const { organizationsSimplified, getOrganizationsSimplified } = useOrganizationModule()
        const { getBillingTemplatesFromApi } = useBillingTemplateModule()

        await getOrganizationsSimplified()

        const selectedOrganization = ref(null)
        const organizationsOptions = organizationsSimplified.value.map((organization) => {
            return {
                label: organization.companyName,
                value: organization.id
            }
        })

        const goBack = () => {
            router.push({ name: AgreementsRouteNames.LIST, query: { page: route.query.page } })
        }

        const goProceed = async (org:string) => {
            const billingTemplateList = await getBillingTemplatesFromApi(org)
            // NOTE. Complicated way to call Quasar dialog, since we have async precondition.
            // Some promise-related fix to dialog component is to be released in Quasar 2.7.1.
            //   -- why not use just "alert()"?
            if (!billingTemplateList.length) {
                if (await new Promise(resolve => $q.dialog({
                    title: 'Billing info required',
                    message: 'This organization has no billing info. Please create a one first.',
                    ok: true
                }).onOk(() => resolve(true)))) {
                    router.push({ name: OrganizationsRouteNames.BILLING_TEMPLATE_NEW, params: { organizationId: org }, query: { page: route.query.page } })
                }
            } else {
                router.push({ name: AgreementsRouteNames.NEW_FORM, params: { organizationId: org }, query: { page: route.query.page } })
            }
        }

        const filteredOptions = ref(organizationsOptions)

        const filterFn = (val: string, update: (arg: () => void) => void) => {
            update(() => {
                const needle = val.toLowerCase()
                filteredOptions.value = organizationsOptions.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            })
        }

        return {
            organizationsOptions,
            selectedOrganization,
            AgreementsRouteNames,
            goBack,
            goProceed,
            filterFn,
            filteredOptions
        }
    }
})
